import axios from "axios";
import { consultationInvoiceCRUD, consultationStats } from "../../constants/apis/clinic_apis";
import { getUserRole, getUserToken } from "../../utils/localStoarege";


export const getConsultationInvoices = async (centerName, query) => {
    const cn = centerName !== "null" ? centerName : null;

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    if (getUserRole() === "operator") {
        const response = await axios.get(consultationInvoiceCRUD + "?page_size=100&machine_name=" + centerName + query || "", config);
        return response;
    } else {
        const response = await axios.get(consultationInvoiceCRUD + `?page_size=100${cn ? "&machine_name=" + cn : ""}` + query || "", config);
        return response;
    }
};

export const getConsultationStats = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(consultationStats + centerName + "/", config);
    return response;
};

export const addNewConsultationInvoices = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(consultationInvoiceCRUD, data, config);
    return response;
};